import ContactActions from './ContactActions';

export default function CtaBand({
  title = 'Stuck on something? Let’s fix it together.',
  text = 'A friendly technician is available in live chat right now — no waiting on hold, no jargon.',
}) {
  return (
    <section className="cta-band">
      <div className="container cta-band__inner">
        <div>
          <h2>{title}</h2>
          <p>{text}</p>
        </div>
        <ContactActions light />
      </div>
    </section>
  );
}
